import React from 'react'
import {Button, Col, Form, ListGroup, UncontrolledAlert} from 'reactstrap'
import Loader from 'react-loader-spinner'
import {provisioningHelpers} from '../../../dataHelpers'
import {getAllControllers, getPastControllers, unassignControllers, getController, getTeam} from "../../../api"
import {ControllerAssignmentListItem, InfoAlert, ModelListTable,} from "../../ui"
import {pageHelpers} from '../'
import {AppError, Controller, UserConfirmationRequest} from "../../../models"
import UnassignControllerIcon from 'react-icons/lib/fa/minus-square'
import '../../../stylesheets/Provision.css'

class UnassignPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {token, isSupport} = props

        let teamID = this.urlParams.team_id
        if (!teamID && this.user) {
            teamID = this.user.activeTeam
        }

        this.state = {
            token,
            isSupport,
            teamID,
            errors: [],
            loading: false,
            unassignedControllers: [],
            availableControllers: [],
            selectedControllers: [],
            userConfirmationRequests: [],
        }

        this.submitForm = this.submitForm.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.fetchUnassignedControllersState = this.fetchUnassignedControllersState.bind(this)
        this.fetchAvailableControllers = this.fetchAvailableControllers.bind(this)
        this.dismissUserConfirmationRequest = this.dismissUserConfirmationRequest.bind(this)
        this.handleSelectedControllersChange = this.handleSelectedControllersChange.bind(this)

        const dealerInfoAlerts = [
            {
                body: "Unassigning controllers moves them out of a customer's inventory and back into your inventory. If the controller is in a customer team, the customer will retain their data from that controller in an archived copy of the controller that shows up in their controller list. Select the controllers you want to unassign below. You can sort the list below by clicking \"Serial Number\", \"Name\", or \"Team Name\".",
                alertKey: "UNASSIGN_DEALER_1",
            },
        ]

        const supportInfoAlerts = [
            {
                body: "Unassigning controllers as a support user removes them from a team's inventory. If the controller is in a customer team, the customer will retain their data from that controller in an archived copy of the controller that shows up in their controller list. Select the controllers you want to unassign below. You can sort the list below by clicking \"Serial Number\", \"Name\", or \"Team Name\".",
                alertKey: "UNASSIGN_SUPPORT_1",
            },
        ]

        this.infoAlerts = (isSupport ? supportInfoAlerts : dealerInfoAlerts)
    }

    async componentWillReceiveProps(nextProps) {
        
        pageHelpers.setupPropsForPage(nextProps, this)
        const {token, isSupport} = nextProps

        let teamID = this.urlParams.team_id
        if (!teamID && this.user) {
            teamID = this.user.activeTeam
        }

        await this.setState({token, isSupport, teamID})

        if (token) {
            let {availableControllers} = this.state
            if (!availableControllers || !availableControllers.length) {
                this.setState({loading: true})
		await this.fetchAvailableControllers()
		// await this.fetchUnassignedControllersState()
		this.setState({loading: false})
            }
        }
    }

    async componentDidMount() {
        let {token} = this.state
        if (token) {
            this.setState({loading: true})
            await this.fetchAvailableControllers()
            await this.fetchUnassignedControllersState()
            this.setState({loading: false})
        }
    }


    dismissUserConfirmationRequest() {
        this.setState({userConfirmationRequests: [], loading: false})
    }

    async fetchAvailableControllers(searchText='') {
        try {
            let {teamID, token, isSupport} = this.state;
            let availableControllers = [];
    
            if (searchText !== '') {
                if (isSupport) {
                    let response = await getAllControllers(token, false, true, false, false, true, true, 1, 100, searchText);
                    availableControllers = response.results;
                } else {
                    let response = await getPastControllers(token, teamID, true, 1, 10000);
                    availableControllers = response.results;
                }
            }
    
            this.setState({ availableControllers });
        } catch (e) {
            console.log(e);
        }
    }

    async fetchUnassignedControllersState() {
        let {unassignedControllers, token} = this.state
        for (let i = 0; i < unassignedControllers.length; i++) {
            let controller = unassignedControllers[i]
            let searchResponse = await provisioningHelpers.searchSerialNumber(token, controller.serialNumber,)
            if (!searchResponse.error && searchResponse.controller) {
                unassignedControllers[i] = searchResponse.controller
            }
        }
        this.setState({unassignedControllers})
    }

    handleSelectedControllersChange(selectedControllers) {
        this.setState({selectedControllers})
    }

    async submitForm(e) {
        e.preventDefault()
        let {selectedControllers, availableControllers} = this.state

        if (!selectedControllers || !selectedControllers.length) {
            let appError = new AppError("No Controllers Selected", "Please select the controllers you wish to unassign.")
            this.setState({errors: [appError], loading: false})
            return
        }

        let confirm = async () => {
            const controlerData = []
               
            
            this.setState({loading: true, userConfirmationRequests: []})
            
            try {
                for (let i = 0; i < selectedControllers.length; i++) {
                    let getControle = await getController(this.token, selectedControllers[i]);
                    let getTeamName = await getTeam(this.token, getControle.team);
                    getControle.team = {'id': getTeamName.id, 'name': getTeamName.name};
                    controlerData.push(getControle);
                }
                await unassignControllers(this.token, selectedControllers);
                await this.setState({unassignedControllers: controlerData, selectedControllers: []})
            } catch (error) {
                console.log(error)
                let appError = new AppError("Failed to Unassign Controllers", "There was an issue unassigning the controller. Please verify the serial number and try again")
                await this.setState({errors: [appError]})
            } 
            this.setState({loading: false})
        }

        let firstController = availableControllers.filter(c => c.id === selectedControllers[0])[0]

        let controllerMessage = (selectedControllers.length > 1 ?
            `these <strong>${selectedControllers.length}</strong> controllers` :
            `<strong>${firstController.userIdentifiableName}</strong>`)

        let request = new UserConfirmationRequest(`Unassign Controller${selectedControllers.length > 1 ? "s" : ""}`,
            `Are you sure you want to unassign ${controllerMessage}?`,
            confirm,
            this.dismissUserConfirmationRequest)
        await this.setState({userConfirmationRequests: [request]})
        
    }

    handleWebSocketResponse(data) {
        let {unassignedControllers} = this.state
        let result = JSON.parse(data)
        let updatedController = Controller.fromAPIObject(result)
        let oldControllers = unassignedControllers.filter(c => c.id === updatedController.id)
        let filteredControllers = unassignedControllers.filter((controller) => controller.id !== updatedController.id)
        if (filteredControllers.length < unassignedControllers.length) {
            let unassignedControllers = filteredControllers
            if (oldControllers && oldControllers.length > 0) {
                let oldController = oldControllers[0]
                updatedController.team = oldController.team
                unassignedControllers.push(updatedController)
            } else {
                unassignedControllers.push(updatedController)
            }
            this.setState({unassignedControllers})
        }
    }

    render() {
        let {
            unassignedControllers, errors, loading, selectedControllers,
            availableControllers, userConfirmationRequests, token, isSupport,
        } = this.state

        return <div className="row col-12 p-0 m-0 justify-content-center">
            <div className="row col-12 p-0 m-0 justify-content-center">
                {this.user && this.user.isSupport && !isSupport ?
                    <UncontrolledAlert color="warning">
                        This is the Dealer view of the Unassign Controllers Page. Support users should only use this for demonstration.
                    </UncontrolledAlert> :
                    null}
                <h1 className="col-12 mb-4 d-block d-sm-none light-sf-orange font-weight-bold"><UnassignControllerIcon
                    className="light-sf-blue mr-2"/>Unassign Controllers From Team</h1>
                <h1 className="col-12 mb-4 d-none d-sm-block light-sf-orange font-weight-bold"><UnassignControllerIcon
                    className="light-sf-blue mr-2"/>Unassign Marksman Controllers From a Team</h1>
                {(loading ?
                        <div className="col-12 align-content-center mt-5 mb-3">
                            <Loader type="TailSpin" color="orange" width={60} height={60}/>
                        </div> :
                        <Col xs={12} className="no-gutters">
                            <Col xs={12} lg={10} className="no-gutters offset-0 offset-lg-1 text-left">
                                <InfoAlert header={"Unassigning Controllers"}
                                           body={this.infoAlerts[0].body}
                                           alertKey={this.infoAlerts[0].alertKey}/>
                                <label>Controllers{selectedControllers && selectedControllers.length ? <span
                                    className="semi-opaque">&ensp;&mdash;&ensp;{selectedControllers.length} Selected</span> : null}</label>
                                <ModelListTable models={availableControllers || []}
                                                fields={["serialNumber", "name", "teamName"]}
                                                searchFields={["serialNumber", "name", "teamName"]}
                                                boldFields={["serialNumber"]}
                                                hideableFields={["name", "teamName"]}
                                                selectable={true}
                                                actionName="Unassign"
                                                onSelectedChange={this.handleSelectedControllersChange}
					        onSearch={this.fetchAvailableControllers}
                                                className=""/>

                                <Form className="p-0 text-center mt-4" onSubmit={this.submitForm}>
                                    <Button className="mt-3 mt-md-0 col-12 col-sm-6 col-md-4">
                                        Unassign
                                    </Button>
                                </Form>
                            </Col>
                        </Col>
                )}

                {pageHelpers.renderErrorModalsForPage(errors, this)}
                {pageHelpers.renderUserConfirmationModals(userConfirmationRequests)}
            </div>
            {(unassignedControllers.length > 0 && token ?
                <div id="provisioned-controllers" className="row mt-4 justify-content-center align-items-center">
                    <hr/>
                    <br/>
                    <h3 className="col-12 mt-3">Unassigned Controllers</h3>
                    <ListGroup>
                        {unassignedControllers.map((controller, idx) => (
                            <ControllerAssignmentListItem controller={controller}
                                                          key={idx}
                                                          token={token}
                                                          handleWebSocketResponse={this.handleWebSocketResponse}/>
                        ))}
                    </ListGroup>
                </div>
                : null)}
        </div>
    }
}

export default UnassignPage



// WEBPACK FOOTER //
// ./src/components/pages/controllers/UnassignPage.js